import { render, staticRenderFns } from "./chart-value-container.vue?vue&type=template&id=af24e216&scoped=true&"
import script from "./chart-value-container.vue?vue&type=script&lang=js&"
export * from "./chart-value-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af24e216",
  null
  
)

export default component.exports